import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ToggleSlideComponent } from '../toggle-slide/toggle-slide.component';

@Component({
  selector: 'app-local-search',
  templateUrl: './local-search.component.html',
  standalone: false,
})

export class LocalSearchComponent {
  @Input() localSearchProduct = '';
  @Input() toggleActive = false;
  @Output() localSearchProductEmitter = new EventEmitter<string>();
  @Output() toggleActiveChange = new EventEmitter<boolean>();
  @ViewChild('demoToggleSlide') demoToggleSlide: ToggleSlideComponent;

  constructor() {}

  triggerDemoToggle() {
    if (this.demoToggleSlide) {
      this.demoToggleSlide.toggleHandler();
      this.toggleActive = !this.toggleActive;
      this.toggleActiveChange.emit(this.toggleActive);

      if (this.toggleActive) {
        this.localSearchProductEmitter.emit(this.localSearchProduct);
      } else {
        this.localSearchProductEmitter.emit('');
      }
    }
  }
}
